import React from 'react'

import { Input } from '@chakra-ui/react'
import DatePicker from 'react-datepicker'

import moment from 'moment'
import { Controller, useFormContext } from 'react-hook-form'
import DummyInput from '../DummyInput/DummyInput'
import FieldWrapper from '../FieldWrapper/FieldWrapper'

import { isNullish } from '@/utils/helper'
const ControlledDatePicker = ({
  name,
  disabled,
  minDate,
  isRequired = true,
  canHighLight = true,
  needPortal = true,
  ...rest
}) => {
  const { getValues } = useFormContext()

  const defaultValue = getValues(name)

  return (
    <Controller
      name={name}
      defaultValue={defaultValue ? new Date(defaultValue) : undefined}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        return (
          <FieldWrapper
            name={name}
            error={error}
            tooltip={moment(value).format('DD-MMM-YYYY')}
            isRequired={isRequired}
            {...rest}
          >
            {disabled && <DummyInput value={value ? moment(value).format('DD-MMM-YYYY') : '(-)'} disabled />}
            {!disabled && (
              <Input
                as={DatePicker}
                zIndex={'9999'}
                portalId={needPortal ? 'root-portal' : ''}
                dateFormat={'dd-MMM-yyyy'}
                selected={value ? new Date(value) : undefined}
                onChange={(e) => {
                  onChange(e)
                }}
                minDate={minDate && minDate != null ? new Date(minDate) : undefined}
                bg={(isNullish(value) || value === '') && isRequired && canHighLight ? 'yellow' : 'white'}
                showYearDropdown
                showMonthDropdown
                yearDropdownItemNumber={15}
                scrollableYearDropdown
                popperPlacement="bottom-end"
                popperModifiers={[
                  {
                    name: 'preventOverflow',
                    options: {
                      rootBoundary: 'viewport',
                      tether: false,
                      altAxis: true,
                    },
                  },
                ]}
              />
            )}
          </FieldWrapper>
        )
      }}
    />
  )
}

export default ControlledDatePicker
